import { usePasswordMask } from './usePasswordMask';
import { useSearch } from './useSearch';
export const useAdornmentVariants = (config) => {
    const passwordMask = usePasswordMask(config || {});
    const search = useSearch(config || {});
    return { passwordMask, search };
};
//# sourceMappingURL=useAdornmentVariants.js.map